export default "__VITE_ASSET__ZITj$zlY__"